import {
  axiosInstanceIservices,
  axiosInstanceReports,
} from 'lib/services/config/axios-config'
import { TRestResponse } from '../restApi.types'
import { TOrganization, TPatientStatusOption } from './organizations.types'
import { useQuery } from 'react-query'

export const getOrganization = async (
  orgId: string
): Promise<TRestResponse<TOrganization>> => {
  try {
    const { data: responseData } = await axiosInstanceIservices.get<
      TRestResponse<TOrganization>
    >(`/organizations/${orgId}`)
    return {
      success: responseData.success,
      message: responseData.message,
      data: responseData.data || undefined,
    }
  } catch (error) {
    console.error(error)
    return {
      success: false,
      message: (error as Error).message,
    }
  }
}

export const useGetOrganization = (orgId: string) => {
  return useQuery({
    queryKey: ['organization', orgId],
    queryFn: () => getOrganization(orgId),
    enabled: !!orgId,
  })
}

export const getPatientStatusOptions = async (
  token: string
): Promise<TRestResponse<TPatientStatusOption[]>> => {
  try {
    const { data: responseData } = await axiosInstanceReports.get(
      `/app/config`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return {
      success: true,
      message: 'data received successfully',
      data: responseData.patient_status_options || undefined,
    }
  } catch (error) {
    console.error(error)
    return {
      success: false,
      message: (error as Error).message,
    }
  }
}

export const useGetPatientStatusOptions = (token: string) => {
  return useQuery({
    queryKey: ['patientStatusOptions', token],
    queryFn: () => getPatientStatusOptions(token),
    enabled: !!token,
    cacheTime: 0,
    staleTime: 0,
    refetchOnMount: 'always',
  })
}
